<template>
    <b-form>
        <div v-show="!fileData.sharedId">
            <p>{{ $t('share.text') }} <strong v-if="fileData">{{ fileData.title }}</strong>.</p>
            <label for="expiresInDays">{{ $t('share.valid') }}</label>
            <b-input type="number" min="1" max="365" step="1" id="expiresInDays"
                     name='shareValidity'
                     v-validate="'required|numeric|min_value:1|max_value:365'"
                     v-model="expiresInDays"
                     :placeholder="$t('project.settings.participants.inviteDlg.validPlaceholder')"
                     :state="!veeErrors.has('shareValidity')"/>
            <span v-show="veeErrors.has('shareValidity')" style="color: red;" class="small">{{ $t('share.validation.period') }}</span>
            <hr>
            <b-row>
                <b-col class="text-right">
                    <b-button type="button" variant="outline-secondary" class="mr-2" @click="closeShareModal()">{{ $t('general.close') }}</b-button>
                    <b-button type="button" variant="outline-info" @click="createFileShareLink">{{ $t('share.create') }}</b-button>
                </b-col>
            </b-row>
        </div>
        <div v-show="fileData.sharedId">
            <b-input-group>
                <b-form-input v-model="fileShareLink" readonly></b-form-input>
                <b-input-group-append>
                    <b-btn variant="outline-success" v-clipboard="fileShareLink">
                        <icon name="clipboard"></icon>
                    </b-btn>
                </b-input-group-append>
            </b-input-group>
            <hr>
            <b-row>
                <b-col class="text-right">
                    <b-button type="button" variant="outline-secondary" class="mr-2" @click="closeShareModal()">{{ $t('general.close') }}</b-button>
                    <b-button type="button" variant="outline-danger" @click="removeFileShareLink" :disabled="!projectPermissions.includes('CANCEL_SHARE_FILE')" >{{ $t('share.deleteLink') }}</b-button>
                </b-col>
            </b-row>
        </div>
    </b-form>
</template>

<script>
import toastr from 'toastr';
import moment from 'moment';
import projectsApi from '../../../api/projects.js';
import i18n from '@/i18n.bootstrap';

export default {
    props: {
        file: Object
    },

    data() {
        return {
            fileData: {
                ...this.file,
                sharedId: undefined
            },
            expiresInDays: 2,
            expirationDate: null,
            projectId: this.$route.params.projectId,
            fileShareLink: ''
        }
    },
    computed: {
        projectPermissions() {
          if(this.$store.state.projects.currentProject.projectData.role){
            return this.$store.state.projects.currentProject.projectData.role.permissions;
          } else {
            return [];
          }
        },
    },

    watch: {
        file(newVal) {
            this.fileData = newVal;
            this.fileShareLink = this.generateLink(this.fileData.sharedId);
        }
    },

    methods: {
        generateLink(sharedId) {
            let { protocol, hostname, port } = window.location;
            if (port && port !== '') {
                return sharedId ? `${protocol}//${hostname}:${port}/colab/#/share/${sharedId}` : '';
            } else {
                return sharedId ? `${protocol}//${hostname}/colab/#/share/${sharedId}` : '';
            }
        },

        createFileShareLink() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    let params = { expires: this.expiresInDays }
                    projectsApi.createFileShareLink(this.projectId, this.fileData.id, params)
                        .then(res => {
                            this.expirationDate = moment(res.data.expires).format("DD.MM.YYYY HH:mm");
                            this.fileData.sharedId = res.data.id;
                            this.fileShareLink = this.generateLink(this.fileData.sharedId);
                        })
                        .catch(err => {
                            console.log(err);
                            this.fileData.sharedId = '';
                            this.fileShareLink = this.generateLink(this.fileData.sharedId);
                        });
                }
            });
        },

        removeFileShareLink() {
            projectsApi.removeFileShareLink(this.projectId, this.fileData.id)
                .then(() => {
                    this.expiresInDays = 2;
                    this.$emit('closeShareModal');
                    toastr.success(i18n.t('share.messages.action.successRevoke'));
                    this.fileData.sharedId = '';
                    this.fileShareLink = this.generateLink(this.fileData.sharedId);
                })
                .catch(err => {
                    console.log(err);
                });
        },

        closeShareModal() {
            this.expiresInDays = 2;
            this.$emit('closeShareModal');
        }
    }
}
</script>
